import React, { useState, useEffect, useContext } from 'react'
import { useFormik } from 'formik'
import CommonContext from '../../../../../custom/context/common/commonContext'
import UserContext from '../../../../../product/context/user/userContext'
import AuthContext from '../../../../../product/context/auth/authContext'
import PrimaryButton from '../../../../../product/components/atoms/PrimaryButton'
import CheckBox from '../../../../../product/components/atoms/CheckBox'
import NoRecordsFound from '../../../../../product/components/atoms/NoRecordsFound'
import { useTranslation } from 'react-i18next'

const UserNotifications = (props) => {
    const commonContext = useContext(CommonContext)
    const userContext = useContext(UserContext)
    const authContext = useContext(AuthContext)
    const { t } = useTranslation()

    const { allNotifications } = commonContext
    const {
        user,
        updatePreference,
        responseStatus: responseStatusUser,
    } = authContext

    const [reload, setReload] = useState(false)

    const initialValues = {
        email_prefer: [],
        user_id: props.data.user_id,
        sms_prefer: [],
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            updatePreference(values)
        },
    })

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.from === 'updatePreference') {
                if (responseStatusUser.status === 'success') {
                    props.cancelFunction()
                }
            }
        }
    }, [responseStatusUser])

    useEffect(() => {
        if (props.data) {
            let userData = props.data
            console.log(props.data, 'ddd')
            formik.values.email_prefer =
                userData.email_notification &&
                userData.email_notification.split(',').length
                    ? userData.email_notification.split(',')
                    : []
            formik.values.sms_prefer =
                userData.sms_notification &&
                userData.sms_notification.split(',').length
                    ? userData.sms_notification.split(',')
                    : []
            setReload(!reload)
        }
    }, [props.data])

    useEffect(() => {
        if (props.additionalfieldUpdate) {
            props.additionalfieldUpdate(formik.values)
        }
    }, [formik.values])

    return (
        <div className="table-responsive dpTable">
            {initialValues && allNotifications.length ? (
                <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                    <table className="table text-left">
                        <thead>
                            <tr>
                                <th scope="col">{t('Notification')}</th>
                                {Object.keys(initialValues).includes(
                                    'email_prefer'
                                ) ? (
                                    <th scope="col">{t('Email')}</th>
                                ) : (
                                    <></>
                                )}
                                {Object.keys(initialValues).includes(
                                    'sms_prefer'
                                ) ? (
                                    <th scope="col">{t('SMS')}</th>
                                ) : (
                                    <></>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {allNotifications.map((data, index) => (
                                <>
                                    <tr
                                        key={data.id}
                                        hidden={
                                            data.email == 0 && data.sms == 0
                                                ? true
                                                : false
                                        }
                                    >
                                        <td>{t(data.description)}</td>
                                        {Object.keys(initialValues).includes(
                                            'email_prefer'
                                        ) ? (
                                            <td>
                                                <div>
                                                    <CheckBox
                                                        name={'email_prefer'}
                                                        label={''}
                                                        checked={
                                                            formik.values[
                                                                'email_prefer'
                                                            ]?.indexOf(
                                                                data.id.toString()
                                                            ) !== -1
                                                                ? true
                                                                : false
                                                        }
                                                        value={data.id.toString()}
                                                        onChange={
                                                            formik.handleChange
                                                        }
                                                        disabled={
                                                            data.email == 0
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                </div>
                                            </td>
                                        ) : (
                                            <></>
                                        )}
                                        {Object.keys(initialValues).includes(
                                            'sms_prefer'
                                        ) ? (
                                            <td>
                                                <div>
                                                    <CheckBox
                                                        name={'sms_prefer'}
                                                        label={''}
                                                        checked={
                                                            formik.values[
                                                                'sms_prefer'
                                                            ]?.indexOf(
                                                                data.id.toString()
                                                            ) !== -1
                                                                ? true
                                                                : false
                                                        }
                                                        value={data.id.toString()}
                                                        onChange={
                                                            formik.handleChange
                                                        }
                                                        disabled={
                                                            data.sms == 0
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                </div>
                                            </td>
                                        ) : (
                                            <></>
                                        )}
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                    <div className="actionButton d-flex justify-content-center align-items-center">
                        <PrimaryButton
                            id="notify_save"
                            type="submit"
                            label={t('SAVE')}
                        />
                    </div>
                </form>
            ) : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default UserNotifications
